(function () {
  function patchExternalCartAddNotification() {
    if (window.__one15ExternalCartAddPatched) return;
    window.__one15ExternalCartAddPatched = true;

    function isCartAddUrl(url) {
      if (!url) return false;
      try {
        return /\/cart\/add(\.js)?$/.test(new URL(url, window.location.origin).pathname);
      } catch {
        return /\/cart\/add(\.js)?$/.test(String(url));
      }
    }

    function bodyHasSections(body) {
      if (!body) return false;

      if (body instanceof FormData) {
        return body.has('sections');
      }

      if (typeof body === 'string') {
        try {
          return Boolean(JSON.parse(body).sections);
        } catch {
          return false;
        }
      }

      return false;
    }

    function getLineItemKey(cartAddData) {
      if (!cartAddData || typeof cartAddData !== 'object') return null;
      if (cartAddData.key) return cartAddData.key;
      if (Array.isArray(cartAddData.items) && cartAddData.items.length) {
        return cartAddData.items[cartAddData.items.length - 1].key;
      }
      return null;
    }

    async function handleExternalCartAdd(cartAddData) {
      if (!cartAddData || cartAddData.status || cartAddData.sections) return;

      const key = getLineItemKey(cartAddData);
      if (!key) return;

      const cart = document.querySelector('cart-notification');
      if (!cart) return;

      const sectionIds = cart.getSectionsToRender().map((section) => section.id).join(',');
      const root = window.Shopify?.routes?.root || '/';
      const sectionsUrl = `${root}?sections=${encodeURIComponent(sectionIds)}&sections_url=${encodeURIComponent(window.location.pathname)}`;
      const sectionsResponse = await fetch(sectionsUrl);

      if (!sectionsResponse.ok) return;

      const sections = await sectionsResponse.json();
      const parsedState = Object.assign({}, cartAddData, { key, sections });

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        await publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'external-cart-add',
          productVariantId:
            cartAddData.variant_id ||
            cartAddData.id ||
            cartAddData.items?.[cartAddData.items.length - 1]?.variant_id,
          cartData: parsedState,
        });
      }

      cart.renderContents(parsedState);
    }

    function maybeHandleCartAddResponse(url, body, response) {
      if (!isCartAddUrl(url) || bodyHasSections(body) || !response?.ok) return;

      response
        .clone()
        .json()
        .then((data) => handleExternalCartAdd(data))
        .catch(() => {});
    }

    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input?.url;
      const body = init?.body;

      return originalFetch.apply(this, arguments).then((response) => {
        maybeHandleCartAddResponse(url, body, response);
        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__one15Method = method;
      this.__one15Url = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (body) {
      this.addEventListener('load', function () {
        if (this.__one15Method?.toUpperCase() !== 'POST') return;
        if (!isCartAddUrl(this.__one15Url) || bodyHasSections(body)) return;
        if (this.status < 200 || this.status >= 300) return;

        try {
          handleExternalCartAdd(JSON.parse(this.responseText));
        } catch {
          // Ignore non-JSON cart add responses.
        }
      });

      return originalSend.call(this, body);
    };
  }

  function patchProductForm() {
    const ProductFormEl = customElements.get('product-form');
    if (!ProductFormEl || ProductFormEl.prototype.__one15Patched) return;

    const originalToggle = ProductFormEl.prototype.toggleSubmitButton;
    ProductFormEl.prototype.toggleSubmitButton = function (disable = true, text) {
      originalToggle.call(this, disable, text);

      const labelSpan = this.submitButton?.querySelector('.product-one15__cta-label') || this.submitButtonText;
      if (!labelSpan) return;

      if (!disable && this.submitButton?.dataset.ctaLabel) {
        labelSpan.textContent = this.submitButton.dataset.ctaLabel;
      } else if (disable && text) {
        labelSpan.textContent = text;
      }
    };

    ProductFormEl.prototype.__one15Patched = true;
  }

  function patchProductFormSubmit() {
    const ProductFormEl = customElements.get('product-form');
    if (!ProductFormEl || ProductFormEl.prototype.__one15SubmitPatched) return;

    const originalOnSubmit = ProductFormEl.prototype.onSubmitHandler;
    ProductFormEl.prototype.onSubmitHandler = function (evt) {
      const qtyInput = this.form?.querySelector('.quantity__input[name="quantity"]');
      if (qtyInput) {
        const min = parseInt(qtyInput.min, 10) || 1;
        let qty = parseInt(qtyInput.value, 10);
        if (Number.isNaN(qty) || qty < min) qty = min;
        if (qtyInput.hasAttribute('max')) {
          qty = Math.min(qty, parseInt(qtyInput.max, 10) || qty);
        }
        qtyInput.value = String(qty);
      }

      return originalOnSubmit.call(this, evt);
    };

    ProductFormEl.prototype.__one15SubmitPatched = true;
  }

  function patchVariantInputAvailability() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    if (window.__one15VariantInputPatched) return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
      const productInfo = document.querySelector(`product-info.product-one15[data-section="${sectionId}"]`);
      if (!productInfo) return;

      const input = productInfo.querySelector('.product-variant-id');
      if (!input) return;

      input.disabled = !(variant && variant.available);
    });

    window.__one15VariantInputPatched = true;
  }
  function patchProductRecommendations() {
    const ProductRecommendationsEl = customElements.get('product-recommendations');
    if (!ProductRecommendationsEl || ProductRecommendationsEl.__one15Patched) return;

    const originalLoad = ProductRecommendationsEl.prototype.loadRecommendations;
    ProductRecommendationsEl.prototype.loadRecommendations = function (productId) {
      if (this.dataset.skipFetchIfRendered === 'true' && this.querySelector('.shop-merchandise__card')) {
        return;
      }
      return originalLoad.call(this, productId);
    };
    ProductRecommendationsEl.__one15Patched = true;
  }

  function scrollThumbIntoView(gallery, activeThumb) {
    const slide = activeThumb.closest('[id^="Slide-"]');
    const slider = gallery.querySelector('[id^="Slider-"]');
    if (!slide || !slider) return;

    const slideLeft = slide.offsetLeft;
    const slideRight = slideLeft + slide.clientWidth;
    const visibleLeft = slider.scrollLeft;
    const visibleRight = visibleLeft + slider.clientWidth;

    if (slideLeft < visibleLeft) {
      slider.scrollTo({ left: slideLeft, behavior: 'smooth' });
    } else if (slideRight > visibleRight) {
      slider.scrollTo({ left: slideRight - slider.clientWidth, behavior: 'smooth' });
    }
  }

  function initGalleryLightbox(gallery) {
    const lightbox = gallery.querySelector('[data-product-one15-lightbox]');
    if (!lightbox || lightbox.dataset.one15LightboxInited === 'true') return;
    lightbox.dataset.one15LightboxInited = 'true';

    const lightboxImage = lightbox.querySelector('[data-product-one15-lightbox-image]');
    const zoomBtn = gallery.querySelector('[data-product-one15-gallery-zoom]');
    const main = gallery.querySelector('.product-one15__gallery-main');

    const getActiveSlide = () =>
      gallery.querySelector('[data-product-one15-main-slide].is-active') ||
      gallery.querySelector('[data-product-one15-main-slide]');

    const openLightbox = () => {
      const slide = getActiveSlide();
      const src = slide?.dataset.zoomSrc;
      if (!src || !lightboxImage) return;

      const activeImg = slide.querySelector('.product-one15__gallery-main-image');
      lightboxImage.src = src;
      lightboxImage.alt = activeImg?.alt || '';
      lightbox.hidden = false;
      lightbox.classList.add('is-open');
      document.body.classList.add('product-one15-lightbox-open');
      lightbox.querySelector('.product-one15__gallery-lightbox-close')?.focus();
    };

    const closeLightbox = () => {
      lightbox.hidden = true;
      lightbox.classList.remove('is-open');
      document.body.classList.remove('product-one15-lightbox-open');
      if (lightboxImage) {
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
      }
    };

    zoomBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openLightbox();
    });

    main?.addEventListener('click', (event) => {
      if (!main.classList.contains('product-one15__gallery-main--zoomable')) return;
      if (event.target.closest('[data-product-one15-gallery-zoom]')) return;
      openLightbox();
    });

    lightbox.querySelectorAll('[data-product-one15-lightbox-close]').forEach((el) => {
      el.addEventListener('click', closeLightbox);
    });

    const onKeydown = (event) => {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    };

    document.addEventListener('keydown', onKeydown);
    lightbox.addEventListener('keydown', onKeydown);
  }

  function initGallery(gallery) {
    if (gallery.dataset.one15GalleryInited === 'true') return;
    gallery.dataset.one15GalleryInited = 'true';

    initGalleryLightbox(gallery);

    const mainSlides = gallery.querySelectorAll('[data-product-one15-main-slide]');
    const thumbs = gallery.querySelectorAll('[data-product-one15-thumb]');
    if (mainSlides.length <= 1 || !thumbs.length) return;
    const thumbSliderComponent = gallery.querySelector('slider-component[id^="GalleryThumbnails-"]');

    const setActive = (mediaId) => {
      mainSlides.forEach((slide) => {
        const isActive = slide.dataset.mediaId === mediaId;
        slide.classList.toggle('is-active', isActive);
      });

      thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) scrollThumbIntoView(gallery, thumb);
      });
    };

    const syncInitialState = () => {
      const activeSlide = gallery.querySelector('[data-product-one15-main-slide].is-active') || mainSlides[0];
      const initialMediaId = activeSlide?.dataset.mediaId || thumbs[0]?.dataset.mediaId;
      if (initialMediaId) setActive(initialMediaId);
    };

    // Ensure slider metrics are ready before first interaction on mobile.
    window.requestAnimationFrame(() => thumbSliderComponent?.resetPages?.());
    window.addEventListener('load', () => thumbSliderComponent?.resetPages?.(), { once: true });
    window.addEventListener('resize', () => thumbSliderComponent?.resetPages?.());

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActive(thumb.dataset.mediaId));
    });

    syncInitialState();
  }

  function relocateBogosWidgets(productInfo) {
    const mount = productInfo.querySelector('[data-product-one15-app-mount]');
    if (!mount) return;

    let moved = false;

    const moveNode = (node) => {
      if (!node || mount.contains(node)) return;
      mount.appendChild(node);
      moved = true;
    };

    productInfo.querySelectorAll(':scope > [id^="bogos-"], :scope > [id*="bogos"]').forEach(moveNode);

    if (moved && typeof document !== 'undefined') {
      document.dispatchEvent(new CustomEvent('bogos:discount-init'));
    }
  }

  function watchBogosWidgets(productInfo) {
    relocateBogosWidgets(productInfo);

    if (productInfo.dataset.one15BogosWatch === 'true') return;
    productInfo.dataset.one15BogosWatch = 'true';

    const observer = new MutationObserver(() => relocateBogosWidgets(productInfo));
    observer.observe(productInfo, { childList: true });

    productInfo.addEventListener('product-info:loaded', () => relocateBogosWidgets(productInfo));

    [250, 1000, 2500].forEach((delay) => {
      window.setTimeout(() => relocateBogosWidgets(productInfo), delay);
    });
  }

  function initSection(root) {
    root.querySelectorAll('[data-product-one15-gallery]').forEach(initGallery);
    watchBogosWidgets(root);
  }

  patchExternalCartAddNotification();

  document.addEventListener('DOMContentLoaded', () => {
    patchProductForm();
    patchProductFormSubmit();
    patchVariantInputAvailability();
    patchProductRecommendations();
    document.querySelectorAll('.product-one15').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.product-one15') || event.target;
    if (section?.classList?.contains('product-one15')) {
      initSection(section);
    }
  });
})();
